import { rememberSignedOutReason } from './sessionMemory';

import type { SignedOutReason } from './sessionMemory';
import type { AuthApi } from '../auth/types';

/**
 * Ends the session at the sign-in service, which then returns to /signed-out. When that redirect
 * cannot start, the session is forgotten in this tab and `fallback` shows /signed-out directly.
 */
export async function endSession(
  auth: AuthApi,
  reason: SignedOutReason,
  fallback: () => Promise<void>,
): Promise<void> {
  rememberSignedOutReason(reason);
  try {
    await auth.signOut();
  } catch {
    await auth.forgetSession().catch(() => undefined);
    await fallback();
  }
}
